/* Animate Scroll */
var linkMenu = false
var scrollTo = function(element) {
    linkMenu = true
    $('html, body').animate({
        scrollTop: $(element).offset().top - 80
    }, 1500, function(){
        //window.location.hash = element
        linkMenu = false
    });
}

/* Init */
var baseLp = function () {
    "use strict";
    return {
        //main function
        init: function () {

            //new WOW().init();

            $(window).scroll(function(){
                
                var el1;
                
                try {
                    el1 = $('section.benefits').offset().top
                } catch (error) { }

                if (!el1) {
                    el1 = $('section.features').offset().top
                }

                var el2 = $('section.started').offset().top
                var scroll = $(window).scrollTop();
                var screen = $(window).height();
                var current = scroll + screen/2;
                if(current < el1){
                    $('.navmenu a').removeClass('active');
                    $('.navmenu a').eq(0).addClass('active');
                }
                if(current > el1 && current < el2){
                    $('.navmenu a').removeClass('active');
                    $('.navmenu a').eq(1).addClass('active');                    
                }
                if(current > el2){
                    $('.navmenu a').removeClass('active');
                    $('.navmenu a').eq(2).addClass('active');                    
                }
            });

            $('header button.mob').click(function(){
                $('nav.mobile').toggleClass('active');
                $(this).toggleClass('active');
            });
            $('nav.mobile button').click(function(){
                $('nav.mobile').toggleClass('active');
            });

            $('.scrollto').click(function(e){
                e.preventDefault();
                scrollTo($(this).attr('href'));
            });

            $('.btn-play').click(function(e){
                e.preventDefault();
                $('#modalVideo').modal('show');
            });

            // setTimeout(function(){
            //     $('#modalSkip').modal('show');
            // },10000);

        }
    };
}();